/* Adapter only: submission, request, spinner, cart rendering and checkout remain Shrine-native. */

(() => {

  if (window.ChristmasSweaterLanding) return;

  window.ChristmasSweaterLanding = true;

  const bindings = new WeakMap();

  const selector = '[data-cs-buybox]';

  function primary() { return document.querySelector(selector); }

  function nativeButton() { return primary()?.querySelector('product-form button[type="submit"]'); }

  function init(root = document) {

    const boxes = [...root.querySelectorAll(selector)];

    if (root.matches?.(selector)) boxes.push(root);

    boxes.forEach(box => {

      if (bindings.has(box)) return;

      const formElement = box.querySelector('product-form');

      const form = formElement?.querySelector('form');

      const button = formElement?.querySelector('[type="submit"]');

      if (!form || !button) return;

      const variants = JSON.parse(box.querySelector('[data-cs-variants]').textContent);

      const currency = JSON.parse(box.querySelector('[data-cs-currency]').textContent);

      const duoDiscount = box.dataset.bundleProduct === box.dataset.productId && currency === 'USD' ? Math.max(0, Number(box.dataset.duoDiscount) || 0) : 0;

      const packs = [...box.querySelectorAll('[data-cs-pack]')];

      const pickers = [...box.querySelectorAll('[data-cs-variant]')];

      if(box.dataset.variantStyle==='buttons')pickers.forEach(p=>{

        const group=document.createElement('div');group.className='cs-size-buttons';group.setAttribute('role','group');group.setAttribute('aria-label',p.previousElementSibling?.textContent || 'Size');

        [...p.options].forEach(opt=>{const b=document.createElement('button');b.type='button';b.textContent=opt.textContent;b.disabled=opt.disabled;b.dataset.csSize=opt.value;b.onclick=()=>{p.value=opt.value;p.dispatchEvent(new Event('change',{bubbles:true}));};group.append(b);});

        p.after(group);p.classList.add('cs-select-enhanced');

      });

      const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(amount / 100);

      let count = packs.length && box.dataset.defaultPack === '2' ? 2 : 1;

      const error = box.querySelector('[data-cs-error]');

      const quantity = box.querySelector('[data-cs-quantity]');

      function chosen(index) {

        const id = pickers[index]?.value || form.querySelector('[name="id"]')?.value;

        return variants.find(v => String(v.id) === String(id));

      }

      function sync() {

        const selected = Array.from({length:count},(_,i)=>chosen(i));

        const v=selected[0];

        const min=v?.min||1, step=v?.step||1, max=v?.max||999;

        let amount=quantity ? Math.min(max,Math.max(min,Math.round(Number(quantity.value)||min))) : min;

        amount=min+Math.floor((amount-min)/step)*step;

        if(quantity){quantity.min=min;quantity.step=step;quantity.max=max;quantity.value=amount;}

        const available = selected.length>0 && selected.every(v=>v?.available) && amount>=min;

        const total = Math.max(0, selected.reduce((sum,v)=>sum+(v?.price || 0),0) * amount - (count * amount >= 2 ? duoDiscount : 0));

        const compare = selected.reduce((sum,v)=>sum+Math.max(v?.compare || 0,v?.price || 0),0) * amount;

        packs.forEach(p=>p.setAttribute('aria-pressed',String(Number(p.dataset.csPack)===count)));

        const activeCard=box.querySelector('[data-cs-pack-card="'+count+'"]');

        const pickerGroup=box.querySelector('.cs-pickers');

        box.querySelectorAll('[data-cs-pack-card]').forEach(card=>card.classList.toggle('cs-selected',card===activeCard));

        if(activeCard && pickerGroup && pickerGroup.parentElement!==activeCard)activeCard.append(pickerGroup);

        const second = box.querySelector('[data-cs-picker-row="2"]');

        if (second) second.hidden=count===1;

        box.querySelectorAll('[data-cs-size]').forEach(b=>{const select=b.closest('[data-cs-picker-row]').querySelector('select');b.setAttribute('aria-pressed',String(select.value===b.dataset.csSize));});

        box.querySelectorAll('.shopify-payment-button').forEach(el=>{el.hidden=count===2;});
        const quantityInput=form.querySelector('[data-cs-form-quantity]');if(quantityInput)quantityInput.value=amount;

        const price = box.querySelector('[data-cs-price]');

        if (price) price.textContent=money(total);

        const compared = box.querySelector('[data-cs-compare]');

        if (compared) { compared.textContent=money(compare); compared.hidden=compare<=total; }

        const solo=box.querySelector('[data-cs-solo-price]'),duo=box.querySelector('[data-cs-duo-price]');

        if(solo)solo.textContent=money(chosen(0)?.price || 0);

        if(duo)duo.textContent=money(Math.max(0,(chosen(0)?.price || 0)+(chosen(1)?.price || 0)-duoDiscount));

        const items=[];

        selected.filter(Boolean).forEach(v=>{const item=items.find(i=>i.id===String(v.id));if(item)item.quantity+=amount;else items.push({id:String(v.id),quantity:amount});});

        // Existing Shrine ProductForm.handleSubmit reads bundleDeals.formVariants,

        // creates items[n] inputs, and invokes its own cart render/animation path.

        formElement.bundleDeals = {formVariants:items};

        const input=form.querySelector('[name="id"]');

        if(input && selected[0]) input.value=selected[0].id;

        if(!button.classList.contains('loading')) {

          button.disabled=!available;

          if(available)button.removeAttribute('aria-disabled');

        }

        let label=button.querySelector('.main-atc__label__text');

        if(!label && button.querySelector('.main-atc__label')) {

          const wrapper=button.querySelector('.main-atc__label');

          wrapper.textContent='';label=document.createElement('span');label.className='main-atc__label__text';

          label.textContent=formElement.dataset.csCtaLabel || window.variantStrings?.addToCart || 'Add to cart';wrapper.append(label);

        }

        if(label){if(!label.dataset.csOriginal)label.dataset.csOriginal=label.textContent;label.textContent=available?label.dataset.csOriginal:(window.variantStrings?.soldOut || box.dataset.unavailable);}

        const inlinePrice=button.querySelector('[id^="main-atc-price-"]');

        if(inlinePrice)inlinePrice.textContent=box.dataset.showPrice==='true'?money(total)+' • ':'';

        error.hidden=available;

        if(!available)error.textContent=box.dataset.unavailable;

        document.querySelectorAll('[data-cs-total]').forEach(el=>el.textContent=money(total));

        document.querySelectorAll('[data-cs-add]').forEach(el=>el.disabled=!available);

        document.dispatchEvent(new CustomEvent('cs:variant',{detail:selected[0] || {}}));

        return available;

      }

      packs.forEach(p=>p.addEventListener('click',()=>{count=Number(p.dataset.csPack);sync();}));

      pickers.forEach(p=>p.addEventListener('change',sync));

      quantity?.addEventListener('change',sync);

      form.addEventListener('submit',event=>{

        if(!sync()){event.preventDefault();event.stopImmediatePropagation();error.focus();}

      },true);

      bindings.set(box,{sync});

      sync();

      if(window.customElements)customElements.whenDefined('product-form').then(()=>{

        if(!box.isConnected)return;

        sync();

        // Shopify multi-item responses return items[]. Notification expects one key.

        // Retain its own renderer and animation, adapting only that response shape.

        const cart=formElement.cart;

        if(cart?.tagName==='CART-NOTIFICATION' && !cart.csMultiItemAdapter){

          const original=cart.renderContents.bind(cart);

          cart.renderContents=function(state,...args){

            if(!state.key && state.items?.length)state={...state,...state.items[0],sections:state.sections};

            return original(state,...args);

          };

          cart.csMultiItemAdapter=true;

        }

      });

    });

    root.querySelectorAll('[data-cs-gallery]').forEach(gallery=>{

      if(gallery.dataset.csReady)return;

      gallery.dataset.csReady='true';

      const track=gallery.querySelector('[data-cs-slides]');

      const buttons=[...gallery.querySelectorAll('[data-cs-slide]')];

      const move=i=>track.scrollTo({left:Math.max(0,Math.min(track.children.length-1,i))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});

      buttons.forEach(b=>b.addEventListener('click',()=>move(Number(b.dataset.csSlide))));

      gallery.querySelector('[data-cs-prev]')?.addEventListener('click',()=>move(Math.round(track.scrollLeft/track.clientWidth)-1));

      gallery.querySelector('[data-cs-next]')?.addEventListener('click',()=>move(Math.round(track.scrollLeft/track.clientWidth)+1));

      track.addEventListener('scroll',()=>buttons.forEach((b,i)=>b.setAttribute('aria-current',String(i===Math.round(track.scrollLeft/track.clientWidth)))),{passive:true});

      if(buttons[0])buttons[0].setAttribute('aria-current','true');

    });

    const box=primary();if(box)bindings.get(box)?.sync();

    refreshSticky();

  }

  function refreshSticky(){

    const button=nativeButton();

    document.querySelectorAll('[data-cs-sticky]').forEach(bar=>{

      bar.classList.toggle('cs-visible',!!button && button.getBoundingClientRect().bottom<0);

    });

  }

  document.addEventListener('click',event=>{

    const proxy=event.target.closest('[data-cs-add]');

    if(!proxy)return;

    const box=primary(),button=nativeButton();

    if(!box || !button)return;

    if(!bindings.get(box)?.sync() || button.disabled){box.scrollIntoView({behavior:'smooth',block:'center'});return;}

    if(button.getAttribute('aria-disabled')==='true' || button.classList.contains('loading'))return;

    button.click();

  });

  document.addEventListener('cs:variant',event=>{

    if(!event.detail.mid)return;

    document.querySelectorAll('[data-cs-slides]').forEach(track=>{

      const index=[...track.children].findIndex(s=>s.dataset.mediaId===String(event.detail.mid));

      if(index>=0)track.scrollTo({left:index*track.clientWidth,behavior:'smooth'});

    });

  });

  window.addEventListener('scroll',refreshSticky,{passive:true});

  window.addEventListener('resize',refreshSticky);

  document.addEventListener('shopify:section:load',e=>init(e.target));

  document.addEventListener('shopify:section:reorder',()=>init());

  document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(refreshSticky));

  document.addEventListener('shopify:block:select',e=>{

    const slide=e.target.closest('.cs-slide');

    if(slide)slide.parentElement.scrollTo({left:slide.offsetLeft-slide.parentElement.offsetLeft,behavior:'smooth'});

    const details=e.target.closest('details.cs-faq');if(details)details.open=true;

  });

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();

})();

